module.exports = __webpack_public_path__ + "static/img/19_點數管理.bcfdbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/19_點數管理.png
// module id = 9bpc
// module chunks = 1